<ng-template #template>

    <div class="modal-body position-relative">
        <div class="mb-10">
            <button type="button" class="close" (click)="cancel()"><i aria-hidden="true" class="ki ki-close"></i></button>
        </div>
        <div class="text-center">
            <img  src="../../../.././../assets/common/images/modalpopup/Group 197280.svg" style="width: 3rem;">
        </div>
        
        <div class="text-dark-75 h3 mb-5 ml-5 mt-10 text-center"> Alert! Resolve dependencies
        </div>
        <div class="text-dark-50 mb-10 ml-2 text-center">
            User cannot be deleted until the associated dependencies are resolved.
        </div>
        <ng-content></ng-content>
        <div class="d-flex justify-content-center">
            <button class="btn btn-outline-danger rounded-0 w-25 mx-6" (click)="cancel()">
                {{'Cancel' | localize}}
            </button><button class="btn btn-primary rounded-0 w-50 mx-6" (click)="yes()">{{'Show Dependencies' | localize}}</button>
        </div>
    </div>
</ng-template>

